// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","408":"song"}[chunkId] + "." + {"177":"ba71eb84","408":"97726906"}[chunkId] + ".css";
};